
import { combineReducers } from 'redux';
import estats from './estats';
import totes from './totes';
import periodeSeleccionat from './periodeSeleccionat';
import detall from './detall';
import formulari from './formulari';
import dataSeleccionada from './dataSeleccionada';
import estacio from './estacio';
import exportacio from './exportacio';

export default combineReducers({
    estacio,
    estats,
    totes,
    periodeSeleccionat,
    detall,
    formulari,
    dataSeleccionada,
    exportacio
});



// WEBPACK FOOTER //
// ./src/reducers/observacio/index.js